import { useInitMicrophonesDevices } from '@core/devices/components/DevicesTest/MicrophoneTest/hooks';
import { useInitWebcamDevices } from '@core/devices/components/DevicesTest/WebcamTest/hooks';

const MobileExternalKeyboardDeviceControls = () => {
  useInitMicrophonesDevices();
  useInitWebcamDevices(false);

  return <></>;
};

export default MobileExternalKeyboardDeviceControls;
